import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import HeaderSocialLinksUi from './header_social_links.ui.jsx';


class HeaderSocialLinks extends Component {

  componentDidMount() {
    // we use jQuery + componentDidMount because handleSocialIconClick expects a jquery event
    $(findDOMNode(this)).on('click', '.social-icon-link', (e)=> {
      getTracker().handleSocialIconClick(e);
    });
  }

  render() {
    const { socialLinks } = this.props;

    return (
      <HeaderSocialLinksUi socialLinks={socialLinks} />
    );
  }

}


HeaderSocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    serviceName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    target: PropTypes.oneOf(['_blank','_parent'])
  }))
};

export default HeaderSocialLinks;


